/**
 * Merges multiple Yup schemas into a single schema to be consumed
 * @param  {...Schema} schemas - schema objects to concat
 */
export const mergeSchemas = (...schemas) => {
  const [first, ...rest] = schemas;
  const merged = rest.reduce((mergedSchemas, schema) => mergedSchemas.concat(schema), first);
  return merged;
};
